import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListProfession from "./ListProfession";
import AddEditForm from "../../AddEditForm";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Breadcrumb from "../../../../utils/BreadCrumb";

export default function VisaProfession(props) {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [rowEditing, setRowEditing] = useState({ id: null, method: null });
  const [submitFormLoading, setSubmitFormLoading] = useState(false);

  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [professions, setProfessions] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });
  const [listLoading, setListLoading] = useState(false);

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create")
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    else
      setAddOrEdit((p) => ({ ...p, open: false, method: "" }));
  }, [location]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems))
  }, [location.pathname]);


  const token = localStorage.getItem("token");
  const getVisaProfession = () => {
    setListLoading(true)
    axios
      .get("/dashboard/visa-profession", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setProfessions(res.data.data);
        setListLoading(false);
      })
      .catch((err) => {
        dispatch(setAppError({ msg: err.message }));
        setListLoading(false);
      });
  };

  useEffect(() => {
    getVisaProfession();
  }, []);

  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(
          `/dashboard/visa-profession/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        getVisaProfession();
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(setAppError({ msg: err?.response?.data.message }));
          }
        } else {
          dispatch(setAppError({ msg: err.message }));
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
  };

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      const body = { name };
      const response = await axios.post(`/dashboard/visa-profession`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      getVisaProfession();
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/visa-profession");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "visa profession");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/visa-profession");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const isCreateMode = location.pathname.endsWith("/visa-profession/create");
  const isEditMode = location.pathname.includes("/visa-profession/edit");

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method)
      navigate("/dashboard/visa-profession");
    setAddOrEdit({});
  }, []);

  useEffect(() => {
    if (isCreateMode && !addOrEdit.method) {
      setAddOrEdit({});
      navigate("/dashboard/visa-profession");
    }
  }, []);


  const commonItems = [
    { label: "VISA/IQAMA PROFESSTION", link: "/dashboard/visa-profession" },
  ];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
      ? [...commonItems, { label: "CREATE", link: "/dashboard/visa-profession" }]
      : commonItems;

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5`}>
        {!addOrEdit.open && (
          <>
            <ListProfession
              professions={professions}
              setProfessions={setProfessions}
              rowEditing={rowEditing}
              setRowEditing={setRowEditing}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={listLoading}
              column={4}
              titles={["S.No.", "Visa Profession", "Action"]}
              addData={addData}
            />
          </>
        )}

        {addOrEdit.open && (
          <AddEditForm
            component="jobPosition"
            form={[
              {
                type: "textarea",
                text: "Visa Profession",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues}
          />
        )}
      </div>
    </>
  );
}
